var render, staticRenderFns
import script from "./SchoolCard3.vue?vue&type=script&lang=js&"
export * from "./SchoolCard3.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCard3.vue?vue&type=style&index=0&id=e7e932bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports